// 表格按数字列排序的共用比较（流量监控、通道健康，决策 D186）。

/** 比较两个可能没有值的数：没有值的不论升降都排在最后，两边都没有值时相等（Array.sort 稳定，保持原顺序）。 */
export function compareNullable(x: number | null, y: number | null, desc: boolean): number {
  if (x === null || y === null) return x === y ? 0 : x === null ? 1 : -1;
  return desc ? y - x : x - y;
}
